import React from 'react';

import type { Apps } from '../types';

type TownsquareContextData = {
  isTownsquareContext: boolean;
  app: Apps;
};

export const TownsquareContextInternal = React.createContext<TownsquareContextData>({
  isTownsquareContext: false,
  app: 'home',
});
